import { Box } from '@mentimeter/ragnar-ui/box';
import { Hotzones, NavigationActions, SlideControls, Toolbar } from '..';
import { PresentationCanvas } from '../sfonx/slide-layout/PresentationCanvas';
import Gestures from '../sfonx/canvas/Gestures';
import ProgressIndicator from '../sfonx/misc/ProgressIndicator';
import { InternalProviders } from '../sfonx/misc/internal-providers';
import { Container } from '../sfonx/canvas/Container';
import Header from '../sfonx/misc/vote-code/Header';
import VoteCode from '../sfonx/misc/vote-code/VoteCode';
import { SlideWrapper } from '../sfonx/slide-layout/SlideWrapper';
import Module from '../sfonx/misc/Module';
import Content from '../sfonx/slide-layout/Content';
import { Indications } from '../sfonx/toolbar/indicators/Indications';
import { Reactions } from '../sfonx/toolbar/indicators/reactions';
import { useQuestion } from '../sfonx/data-mediation';
import { VoteIndicator } from '../sfonx/toolbar/indicators/VoteIndicator';
import { MediaOverlay } from '../sfonx/misc/media-overlay/MediaOverlay';

export const EmbedPresentation = () => {
  const { theme_settings } = useQuestion();

  return (
    <Container scaleToWindow>
      {(style) => (
        <>
          <Box
            extend={({ theme }) => ({
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              transition: `background ${theme.durations[2]}s ease`,
              background: theme.colors.bg,
            })}
          />
          <div style={style}>
            <Box overflow="hidden" width="100%" height="100%">
              <PresentationCanvas
                slideImage={theme_settings?.background_cropped_image_url}
              >
                <Header>
                  <VoteCode />
                </Header>
                <Box
                  width="100%"
                  height="100%"
                  flex="1 1 auto"
                  zIndex={1}
                  flexDirection="row"
                >
                  <Gestures>
                    <Content>
                      <SlideWrapper>
                        <Module />
                      </SlideWrapper>
                    </Content>
                    <MediaOverlay />
                    <Indications>
                      <Reactions />
                      <VoteIndicator />
                    </Indications>
                  </Gestures>
                </Box>
                <ProgressIndicator />
              </PresentationCanvas>
              <NavigationActions />
              <Toolbar alwaysShow>
                <Hotzones>
                  <Hotzones.All>
                    <SlideControls />
                  </Hotzones.All>
                </Hotzones>
              </Toolbar>
            </Box>
          </div>
        </>
      )}
    </Container>
  );
};

export const Embed = () => (
  <InternalProviders>
    <EmbedPresentation />
  </InternalProviders>
);
